import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------
// color="primary" buttons use Bright Blue (secondary) for CTAs.
// Dark Blue (primary) remains for structure via palette.primary.
// ----------------------------------------------------------------------

export default function Button(theme) {
  const action = theme.palette.secondary;
  const actionShadow = theme.customShadows.secondary;

  const containedAction = {
    backgroundColor: action.main,
    color: action.contrastText,
    boxShadow: actionShadow,
    "&:hover": {
      backgroundColor: action.dark,
      boxShadow: `0 8px 16px 0 ${alpha(action.dark, 0.28)}`,
    },
  };

  const outlinedAction = {
    borderColor: action.main,
    color: action.main,
    "&:hover": {
      borderColor: action.dark,
      backgroundColor: alpha(action.main, 0.08),
      color: action.dark,
    },
  };

  return {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
        },
        sizeLarge: {
          height: 48,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          "&:hover": {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: containedAction,
        containedSecondary: containedAction,
        outlinedPrimary: outlinedAction,
        outlinedSecondary: outlinedAction,
        textPrimary: {
          color: action.main,
          "&:hover": {
            backgroundColor: alpha(action.main, 0.08),
          },
        },
        outlinedInherit: {
          border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
